import React, { useEffect, useState } from 'react';
import { addHeadEntry, HeadSpec, nextHeadOrder } from './headStore';

/**
 * Lapcím, meta-tagek, canonical link és JSON-LD a <head>-be. Amíg a komponens csatolva
 * van, a bejegyzése él; a legmélyebb / legutóbb csatolt nyer (cím, azonos nevű meta),
 * lecsatoláskor az alatta lévő (végül az index.html-lel egyező alap) érték tér vissza.
 */
export function useHead(spec: HeadSpec): void {
  const [order] = useState(nextHeadOrder);
  // Tartalom szerinti függőség: az inline objektum minden rendereléskor új, a tartalma nem.
  const serialized = JSON.stringify(spec);
  useEffect(() => addHeadEntry(order, JSON.parse(serialized) as HeadSpec), [order, serialized]);
}

/** A useHead komponens-alakja (JSX-ben, feltételesen is kitehető). */
const Head: React.FC<HeadSpec> = (props) => {
  useHead(props);
  return null;
};

export default Head;
